/* global axios */
import ApiClient from '../ApiClient';

class FBChannel extends ApiClient {
  constructor() {
    super('facebook', { accountScoped: true });
  }

  // Conexão inicial e reconexão são o MESMO fluxo: refazer o login OAuth.
  // O callback encontra o canal existente pelo facebook_id e atualiza
  // (ver Facebook::CallbacksController) — não existe endpoint separado de
  // "atualizar credenciais manualmente".
  createAuthorization() {
    return axios.post(`${this.baseUrl()}/facebook/authorization`);
  }

  // Fase 1.3 — lista as Pages stashed pra escolha, quando a conta gerencia
  // mais de uma.
  fetchPagesForSelection(selectionToken) {
    return axios.get(`${this.baseUrl()}/facebook/authorization/pages`, {
      params: { selection_token: selectionToken },
    });
  }

  // Finaliza a criação do inbox com a Page escolhida.
  finalizeAuthorization({ selectionToken, facebookId }) {
    return axios.post(`${this.baseUrl()}/facebook/authorization`, {
      selection_token: selectionToken,
      facebook_id: facebookId,
    });
  }
}

export default new FBChannel();
